export default "__VITE_ASSET__CbgQJIwP__"